import { render, staticRenderFns } from "./addIngredient.vue?vue&type=template&id=86906d4a&scoped=true"
import script from "./addIngredient.vue?vue&type=script&lang=js"
export * from "./addIngredient.vue?vue&type=script&lang=js"
import style0 from "./addIngredient.vue?vue&type=style&index=0&id=86906d4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86906d4a",
  null
  
)

export default component.exports